module.exports = __webpack_public_path__ + "img/52.114f867e.png";